module.exports = ".texto-secundario {\n  color: #98a6ad; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-cxc/modal-nota-credito/modal-nota-credito.component.scss
// module id = ./src/app/components/reporte-cxc/modal-nota-credito/modal-nota-credito.component.scss
// module chunks = main